import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import InviteFriendFlag from 'Components/InviteFriendFlag';
const InviteFriendAuth = loadable(() => pMinDelay(import('./InviteFriendAuth'), 300), {
  fallback: <Loading />,
});

const AsyncInviteFriend = props => {
  
  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType:
      props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${props.userAgent.device?.type} hide-betslip hide-sticky-navigation`,
      },
    },
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <InviteFriendFlag>
        <InviteFriendAuth { ...props } />
      </InviteFriendFlag>
    </ApplicationLayout>
  );
};

AsyncInviteFriend.propTypes = {
  userAgent: PropTypes.object,
};

export default AsyncInviteFriend;
